// api
import { fetchApi } from '@/api'
// actions
const cafeteriaEnlistmentAll = (context) => {
  let url = 'cafeteria/enlistment'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_ENLISTMENT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaEnlistmentForm = (context) => {
  let url = 'cafeteria/enlistment/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_ENLISTMENT_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaEnlistmentShow = (context) => {
  let url = 'cafeteria/enlistment'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_ENLISTMENT_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const cafeteriaEnlistmentCreate = (context) => {
  let url = 'cafeteria/enlistment/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_ENLISTMENT_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaEnlistmentUpdate = (context) => {
  let url = 'cafeteria/enlistment'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('CAFETERIA_ENLISTMENT_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaEnlistmentDelete = (context, payload) => {
  let url = 'cafeteria/enlistment'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('CAFETERIA_ENLISTMENT_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  cafeteriaEnlistmentAll,
  cafeteriaEnlistmentForm,
  cafeteriaEnlistmentShow,
  cafeteriaEnlistmentCreate,
  cafeteriaEnlistmentUpdate,
  cafeteriaEnlistmentDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/enlistment/actions.js